import { __spreadArray, __assign } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import ZigDropdown from '../../../../display/ZigDropdown/index.js';
import React__default, { useMemo } from 'react';
import { DropdownItem } from '../../styles.js';
import CheckBoxFilter from '../../filters/CheckBoxFilter/index.js';
import { DropdownResetButton } from '../atoms/DropdownResetButton/index.js';
import { DropdownLabel } from '../atoms/DropdownLabel/index.js';
import { useLongestString } from '../util.js';
import { FiltersCount } from '../atoms/FilterCount/index.js';
import MobileFilterButton from '../atoms/MobileFilterButton/index.js';
import { Box } from '@mui/material';

var FILTERS_COUNT_WIDTH = 16;
var CheckboxFilterDropdown = function (_a) {
    var filter = _a.filter, onChange = _a.onChange, resetFilter = _a.resetFilter, minSpace = _a.minSpace, mobile = _a.mobile, prefixId = _a.prefixId, showFullSingleValue = _a.showFullSingleValue;
    var stringAll = "All";
    var stringNone = "None";
    var displayValue = useMemo(function () {
        if (!filter.value)
            return stringAll;
        var options = filter.options.filter(function (option) { var _a; return (_a = filter.value) === null || _a === void 0 ? void 0 : _a.includes(option.value); });
        return options.length > 0
            ? options.length === 1 && showFullSingleValue
                ? options[0].label
                : options.length
            : stringNone;
    }, [filter.value, filter.options]);
    var longestWidth = useLongestString(__spreadArray([
        stringAll,
        stringNone
    ], (showFullSingleValue ? filter.options.map(function (o) { return o.label; }) : []), true));
    if (mobile) {
        return (React__default.createElement(MobileFilterButton, { filter: filter, onChange: onChange, resetFilter: resetFilter, label: typeof displayValue === "number" ? (React__default.createElement(Box, { display: "flex", gap: "6px", alignItems: "center" },
                filter.label,
                ": ",
                React__default.createElement(FiltersCount, null, displayValue))) : ("".concat(filter.label, ": ").concat(displayValue)), prefixId: prefixId }));
    }
    return (React__default.createElement(ZigDropdown, { id: "".concat(prefixId, "__checkbox-").concat(filter.id), component: function (_a) {
            var open = _a.open;
            return (React__default.createElement(DropdownItem, { active: open },
                React__default.createElement(DropdownLabel, { minSpace: minSpace !== null && minSpace !== void 0 ? minSpace : Math.max(longestWidth, FILTERS_COUNT_WIDTH), label: filter.label, value: typeof displayValue === "number" ? (React__default.createElement(FiltersCount, null, displayValue)) : (displayValue) })));
        }, options: [
            {
                element: (React__default.createElement(CheckBoxFilter, { filter: __assign(__assign({}, filter), { label: "" }), onChange: function (f) {
                        onChange(__assign(__assign({}, f), { label: filter.label }));
                    } })),
            },
            { separator: true },
            {
                element: (React__default.createElement(DropdownResetButton, { id: "filters__checkbox-dropdown-".concat(filter.id, "-reset"), onClick: resetFilter })),
            },
        ] }));
};

export { CheckboxFilterDropdown as default };
